import { SvgIconProps } from './icon-props';

export default function CallAltInverted({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
			<path d="M30 30A28 28 0 0 1 2 2h10.77v7.69l-4.31 2.15a23.87 23.87 0 0 0 11.7 11.7l2.15-4.31H30z" />
		</svg>
	);
}
